import { FormattedMessage } from 'react-intl'
import Text from 'shared/components/typography/Text'
import Link from 'shared/components/typography/Link'
import { TERMS_OF_USE_HREF } from 'shared/constants/links.ts'
import { lang } from './lang'

export default function Terms() {
  return (
    <Text fontType="body" fontSize={14} color="var(--grey-300)" textAlign="center" display="block">
      <FormattedMessage
        {...lang.termsAgree}
        values={{
          terms: (
            <Link href={TERMS_OF_USE_HREF} target="_blank" rel="noopener noreferrer">
              <FormattedMessage {...lang.terms} />
            </Link>
          ),
        }}
      />
    </Text>
  )
}
